if (!customElements.get("product-image-slider")) {
  customElements.define(
    "product-image-slider",
    class ProductImageSlider extends window.Component {
      constructor() {
        super();
        this.onChangeVariant();
      }

      onChangeVariant() {
        this.subscribeContext((state, previousState) => {
          if (state.variantSelected != previousState.variantSelected) {
            const featured_image = state.variantSelected?.featured_image;
            const imageId = featured_image?.id || "";
            if (!imageId) return;
            const sliderImage = this.querySelector(`[image-id="${imageId}"]`);
            if(!sliderImage) return;
            const index = sliderImage.getAttribute("data-slick-index");
            $(this).find(".image--slider").slick("slickGoTo", index);
          }
        });
      }
    }
  );
}
